var meetings = [
    // 2025-2026 Competition Meetings
    {
        'date': new Date(2025, 8,7),
        'name': 'Practice Meeting',
        'ShortLocation': 'WVA',
        'LongLocation': 'Willamette Valley Academy',
        'Time': '10:00 AM - 12:00 PM',
        'Description': (<span><strong>Parents are invited to first ~30 minutes.</strong> Information on upcoming year (including ARML, HMMT, TST, POTDs, and more). We will split into groups for contest practice and learning contest techniques.</span>)
    },
    
    // 2024-2025 Competition Meetings
    {
        'date': new Date(2024, 9, 6),
        'name': 'Practice Meeting',
        'ShortLocation': 'WVA',
        'LongLocation': 'Willamette Valley Academy',
        'Time': '2:00 PM - 4:00 PM',
        'Description': (<span><strong>Parents are invited to first 30-60 minutes.</strong> Information on upcoming year (including ARML, HMMT, TST, POTDs, and more). </span>)
    },
    {
        'date': new Date(2024, 10, 10),
        'name': 'Practice Meeting',
        'ShortLocation': 'WVA',
        'LongLocation': 'Willamette Valley Academy',
        'Time': '2:00 PM - 4:00 PM',
        'Description': (<span>Competition practice. <strong>Please bring a device.</strong></span>)
    },
    {
        'date': new Date(2025, 1, 22),
        'name': 'Practice Meeting',
        'ShortLocation': 'WVA',
        'LongLocation': 'Willamette Valley Academy',
        'Time': '2:00 PM - 4:00 PM',
        'Description': (<span>Competition practice. <strong>Please bring a device.</strong></span>)
    },
    {
        'date': new Date(2025, 3, 6),
        'name': 'Practice Meeting',
        'ShortLocation': 'WVA',
        'LongLocation': 'Willamette Valley Academy',
        'Time': '2:00 PM - 4:00 PM',
        'Description': (<span>Competition practice. <strong>Please bring a device.</strong></span>)
    },
    {
        'date': new Date(2025, 4, 4),
        'name': 'Practice Meeting',
        'ShortLocation': 'WVA',
        'LongLocation': 'Willamette Valley Academy',
        'Time': '2:00 PM - 4:00 PM',
        'Description': (<span>Competition practice. <strong>Please bring a device.</strong></span>)
    },
    // 2024-2025 TSTs
    {
        'date': new Date(2024, 11, 9), 
        'name': 'HMMT TST',
        'ShortLocation': 'WVA', 
        'LongLocation': 'Willamette Valley Academy',
        'Time': '2:00 PM - 5:00 PM',
        'Description': (<span>Team Selection Test for HMMT. <strong>Please bring a pencil or pen.</strong></span>)
    },
    {
        'date': new Date(2025, 0, 18), 
        'name': 'HMMT TST',
        'ShortLocation': 'WVA', 
        'LongLocation': 'Willamette Valley Academy',
        'Time': '2:00 PM - 4:30 PM',
        'Description': (<span>Team Selection Test for ARML. <strong>Please bring a pencil or pen.</strong></span>)
    },

    // classes 
    // October - Group Theory
    {
        'date': new Date(2024, 9, 12),
        'name': 'Group Theory Class 1',
        'ShortLocation': 'WVA',
        'LongLocation': 'Willamette Valley Academy',
        'Time': '1:00 PM - 2:30 PM',
        'Description': (<span>Introduction to the essense of group theory. We go over the definition of a group and the intuition behind what makes groups important.</span>)
    },
    {
        'date': new Date(2024, 9, 19),
        'name': 'Group Theory Class 2',
        'ShortLocation': 'WVA',
        'LongLocation': 'Willamette Valley Academy',
        'Time': '1:00 PM - 2:30 PM',
        'Description': (<span>Introduction to the essense of group theory. We continue talking about the importance of groups, going over some special types.</span>)
    },
    {
        'date': new Date(2024, 9, 26),
        'name': 'Group Theory Class 3',
        'ShortLocation': 'Online',
        'LongLocation': 'Discord Voice Call',
        'Time': '1:00 PM - 2:30 PM',
        'Description': (<span>Introduction to the essense of group theory. We move to the specific topic of group actions, which take the symmetries present and apply them to different sets.</span>)
    },
    {
        'date': new Date(2024, 10, 2),
        'name': 'Group Theory Class 4',
        'ShortLocation': 'Online',
        'LongLocation': 'Discord Voice Call',
        'Time': '1:00 PM - 2:30 PM',
        'Description': (<span>Introduction to the essense of group theory. As a culmination of everything from the past weeks, we go over a special and advanced theorem in Group Theory which has both beautiful math behind it as well as many practical applications.</span>)
    },

    // Competitions
    {
        'date': new Date(2025, 1, 15),
        'name': 'HMMT',
        'ShortLocation': 'Boston, MA',
        'LongLocation': 'MIT & Harvard Universities',
        'Time': 'Multi-day trip.',
        'Description': (<span>We will leave on the 13th or 14th (Thu/Fri) and return on the 16th (Sun).</span>)
    },
    {
        'date': new Date(2025, 4, 30),
        'name': 'ARML',
        'ShortLocation': 'Reno, NV',
        'LongLocation': 'University of Nevada, Reno, campus',
        'Time': 'Multi-day trip.',
        'Description': (<span>Groups will leave on the 29th (Thu) and 30th (Fri), and will return on the 31st (Sat).</span>)
    },
    
    {
            'date': new Date(2026, 4, 31),
            'name': 'ARML Competition',
            'ShortLocation': 'WVA',
            'LongLocation': 'Willamette Valley Academy',
            'Time': '10:00 AM - 5:00 PM',
            'Description': (<span>in-person ARML Competition</span>)
        },
    {
            'date': new Date(2026, 9, 19),
            'name': 'Practice Meeting',
            'ShortLocation': 'WVA',
            'LongLocation': 'Willamette Valley Academy',
            'Time': '10:00 AM - 12:00 PM',
            'Description': (<span>Practice meeting - please bring a device, notebook, and a pencil</span>)
        },
    {
            'date': new Date(2025, 9, 19),
            'name': 'Practice Meeting',
            'ShortLocation': 'WVA',
            'LongLocation': 'Willamette Valley Academy',
            'Time': '10:00 AM - 12:00 PM',
            'Description': (<span>Practice meeting - please bring a device, notebook, and a pencil</span>)
        },
    {
            'date': new Date(2025, 10, 16),
            'name': 'Practice Meeting',
            'ShortLocation': 'WVA',
            'LongLocation': 'Willamette Valley Academy',
            'Time': '10:00 AM - 12:00 PM',
            'Description': (<span>Practice meeting - please bring a device, notebook, and a pencil</span>)
        },
    {
            'date': new Date(2025, 11, 7),
            'name': 'December HMMT Team Selection Test',
            'ShortLocation': 'WVA',
            'LongLocation': 'Willamette Valley Academy',
            'Time': '10:00 AM - 12:00 PM',
            'Description': (<span>This is the December Harvard-MIT selection test. Please bring writing utensils, paper and problems will be provided. This is restricted to high schoolers.</span>)
        },

    {
            'date': new Date(2026, 0, 18),
            'name': 'January ARML Team Selection Test',
            'ShortLocation': 'WVA',
            'LongLocation': 'Willamette Valley Academy',
            'Time': '10:00 AM - 12:30 PM',
            'Description': (<span>This is the January ARML selection test. Please bring writing utensils & completely blank scratch paper. You will not need protractors, compasses, calculators, etc. There will be 2 general rounds each 50 minutes long and a 25 minute lightning round.</span>)
        },

    {
            'date': new Date(2026, 2, 7),
            'name': 'March ARML Team Selection Test',
            'ShortLocation': 'WVA',
            'LongLocation': 'Willamette Valley Academy',
            'Time': '10:00 AM - 12:45 PM',
            'Description': (<span>This is the March ARML selection test. Please bring writing utensils & completely blank scratch paper. You will not need protractors, compasses, calculators, etc. There will be a mock ARML individual round consisting of 5 sets of pairs of problems each taking 10 minutes, and a 75 minute proof round.</span>)
        },
    {
        'date': new Date(2026, 8, 26),
        'name': 'September Meeting',
        'ShortLocation': 'WVA',
        'LongLocation': 'Willamette Valley Academy',
        'Time': '10:00 AM - 12:00 PM',
        'Description': (<span>First meeting of the season! Bring paper & a writing utensil. Parents are encouraged to join for the first 30 minutes during our informational session.</span>),
        'DiscordEventId': '1551158364338126900'
    },
]

export default meetings;
